import React from 'react';
import { useTwilioStatus } from '../../hooks/useTwilioStatus';
import styles from './twilio-status-indicator.module.css';

const TwilioStatusIndicator = () => {
  const { status, isReady, isInitializing } = useTwilioStatus();

  const getStatusConfig = () => {
    switch (status) {
      case 'initializing':
        return {
          color: '#ffc107',
          text: 'Conectando servicio de llamadas...',
          icon: '🔄'
        };
      case 'ready':
        return {
          color: '#28a745',
          text: 'Servicio de llamadas listo',
          icon: '📞'
        };
      case 'disconnected':
      default:
        return {
          color: '#dc3545',
          text: 'Servicio de llamadas desconectado',
          icon: '📞'
        };
    }
  };

  const statusConfig = getStatusConfig();

  // Solo mostrar cuando está inicializando o por los primeros segundos cuando está listo
  const [showIndicator, setShowIndicator] = React.useState(false);
  const [autoHide, setAutoHide] = React.useState(false);

  React.useEffect(() => {
    if (isInitializing) {
      setShowIndicator(true);
      setAutoHide(false);
    } else if (isReady && !autoHide) {
      // Mostrar por 3 segundos cuando esté listo
      setShowIndicator(true);
      const timer = setTimeout(() => {
        setShowIndicator(false);
        setAutoHide(true);
      }, 3000);
      return () => clearTimeout(timer);
    } else if (!isReady && !isInitializing) {
      // Mostrar inmediatamente si está desconectado
      setShowIndicator(true);
      setAutoHide(false);
    }
  }, [isInitializing, isReady, autoHide]);

  if (!showIndicator) return null;

  return (
    <div 
      className={styles.statusIndicator}
      style={{ 
        backgroundColor: statusConfig.color,
        opacity: isInitializing ? 1 : 0.9
      }}
    >
      <span className={styles.icon}>
        {isInitializing ? (
          <span className={styles.spinner}>⟳</span>
        ) : (
          statusConfig.icon
        )}
      </span>
      <span className={styles.text}>{statusConfig.text}</span>
    </div>
  );
};

export default TwilioStatusIndicator;